import api from "src/store/features/api";
import { useAuth } from "src/providers/AuthProvider";
import { isUkCountry } from "../isUkCountry";

export default function useIsUkUserCountry(): boolean {
  const { isAuthenticated } = useAuth();
  const { data } = api.useGetUserDatav2Query(undefined, { skip: !isAuthenticated });
  return isUkCountry(data?.address?.country);
}
